var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button",on:{"click":_vm.print}},[_c('a-icon',{staticStyle:{"font-size":"16px","margin-bottom":"8px"},attrs:{"type":"printer"}}),_c('span',[_vm._v("打印")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }